import React from 'react';
import PropTypes from 'prop-types';

import keyBy from 'lodash/keyBy';
import filter from 'lodash/filter';
import map from 'lodash/map';

import convert from 'utils/dateTools';

import { FormattedMessage } from 'react-intl';

import RootField from 'components/form/RootField';

import Subheader from 'material-ui/Subheader';
import Paper from 'material-ui/Paper';
import { Col, Row } from 'react-flexbox-grid';
import Truncate from 'components/Truncate';

import {
  // ATTACHMENT,
  CHECKBOX,
  DATE,
  RADIO,
  SCALE,
  TEXT_FIELD,
} from '../constants/InputTypes';
import pallet from '../constants/colors';

const styles = {
  subheader: {
    fontFamily: '"Helvetica Neue",Helvetica,Arial,sans-serif',
    fontSize: 18,
    fontWeight: 500,
  },
  input: {
    marginBottom: 16,
    marginTop: 8,
    padding: 8,
  },
  questionRoot: {
    padding: 16,
  },
  question: {
    display: 'flex',
    flexDirection: 'column',
    paddingBottom: 16,
    fontWeight: 500,
  },
  label: {
    color: 'rgb(176, 176, 176)',
  },
  description: {
    color: 'rgb(95, 95, 95)',
    fontSize: 14,
    fontWeight: 'normal',
  },
  comment: {
    color: 'rgb(95, 95, 95)',
    marginTop: 16,
  },
  checkboxGroup: {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    marginTop: 32,
  },
  answer: {
    display: 'flex',
    flexDirection: 'column',
    marginBottom: 16,
  },
  errorText: {
    color: pallet.errorColor,
  },
  ansText: {
    display: 'flex',
    flexDirection: 'column',
  },
};

const Answer = ({
  text,
  showComment,
  comment,
  title,
}) => (
  <Col xs={12} style={styles.answer} >
    <span style={styles.label}>{title}</span>
    <span style={styles.ansText}>{text.length ? map(text, (t, i) => <Truncate key={i} message={t} />) : <span style={styles.errorText}>Ekkert svar.</span>}</span>
    {/* AllowComment &&
      <span style={styles.label}>{'Athugasemd starfsmanns'}</span>
    */}
    {showComment &&
      <span style={styles.comment}>{comment ? <Truncate length={300} message={comment} /> : <span style={styles.errorText}>Engin athugasemd.</span>}</span>
    }
  </Col>
);

Answer.defaultProps = {
  text: [],
  showComment: false,
  comment: '',
  title: '',
};

Answer.propTypes = {
  text: PropTypes.array,
  showComment: PropTypes.bool,
  comment: PropTypes.string,
  title: PropTypes.node,
};


class QAElement extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  renderComment = () => {
    const { QAElementID, AllowComment, QAInput } = this.props;
    const { QAInputAnswerType } = QAInput;
    if (!AllowComment) { return <div />; }
    return (
      <RootField
        multiLine
        type={TEXT_FIELD}
        hintText={<FormattedMessage id="qaelement.answer.comment" />}
        name={`COMMENT-${QAInputAnswerType}-${QAElementID}`}
      />
    );
  }
  renderInput = () => {
    const {
      QAInputOptions, HrQualificationScaleEntries, MaxAnswers, QAInputAnswerType,
    } = this.props.QAInput;
    const options = QAInputOptions && QAInputOptions.map(e => ({ ...e, label: e.QAInputOptionLabel, value: e.QAInputOptionID }));
    const scaleOptions = HrQualificationScaleEntries &&
      HrQualificationScaleEntries.map(e => ({ ...e, label: e.HrQualificationScaleEntryName, value: e.HrQualificationScaleEntryID }));
    const { QAElementID, disabled } = this.props;
    const isMultiple = MaxAnswers > 1;

    switch (QAInputAnswerType) {
      case 0:
        return (
          <RootField
            multiLine
            disabled={disabled}
            rowsMax={6}
            type={TEXT_FIELD}
            hintText={<FormattedMessage id="qaelement.input.text" />}
            name={`${QAInputAnswerType}-${QAElementID}`}
          />
        );
      case 1:
        return (
          <span>At this moment ATTACHMENT questions are not supported</span>
          /*
          <RootField
            type={ATTACHMENT}
            name={`${QAInputAnswerType}-${QAElementID}-${ATTACHMENT}`}
          />
          */
        );
      case 2:
        return (
          <RootField
            type={RADIO}
            options={options}
            disabled={disabled}
            hintText={<FormattedMessage id="qaelement.input.select" />}
            name={`${QAInputAnswerType}-${QAElementID}`}
          />
        );
      case 3:
        return (
          <div style={styles.checkboxGroup}>
            {options && options.map(({ QAInputOptionLabel, QAInputOptionID }) =>
              (<RootField
                key={QAInputOptionID}
                type={CHECKBOX}
                disabled={disabled}
                label={QAInputOptionLabel}
                name={`${QAInputAnswerType}-${QAElementID}-${btoa(QAInputOptionLabel)}`}
              />))}
          </div>
        );
      case 4:
        return (
          <RootField
            type={TEXT_FIELD}
            multiLine
            disabled={disabled}
            rows={2}
            rowsMax={6}
            hintText={<FormattedMessage id="qaelement.input.text" />}
            name={`${QAInputAnswerType}-${QAElementID}`}
          />
        );
      case 5:
        return (
          <RootField
            type={DATE}
            multiple={isMultiple}
            disabled={disabled}
            name={`${QAInputAnswerType}-${QAElementID}`}
          />
        );
      case 6:
        return (
          <RootField
            type={SCALE}
            options={scaleOptions}
            disabled={disabled}
            hintText={<FormattedMessage id="qaelement.input.select" />}
            name={`${QAInputAnswerType}-${QAElementID}`}
          />
        );
      default:
        return (
          <span>UNEXPECTED_ANSWER_TYPE</span>
        );
    }
  }

  renderFinalAnswer = () => {
    const {
      QAInput, finalAnswers, QAElementID, AllowComment,
    } = this.props;
    const { QAInputAnswerType } = QAInput;
    const finAns = keyBy(finalAnswers, 'QAElementID')[QAElementID];
    let finalAnswerTexts = map(filter(finalAnswers, ['QAElementID', QAElementID]), e => e.QAAnswerText);
    if (QAInputAnswerType === 5) {
      finalAnswerTexts = map(finalAnswerTexts, convert);
    }
    return (
      <Row style={styles.answers}>
        <Answer
          title={<FormattedMessage id="qaelement.answer.final" />}
          text={finalAnswerTexts}
          showComment={AllowComment}
          comment={finAns ? finAns.QAAnswerComment : ''}
        />
      </Row>
    );
  }

  renderAnswers = () => {
    const {
      QAInput, employeeAnswers, managerAnswers, QAElementID, AllowComment, showOnlyEmployeeAnswers,
    } = this.props;
    const { QAInputAnswerType } = QAInput;
    const empAns = keyBy(employeeAnswers, 'QAElementID')[QAElementID];
    const manAns = keyBy(managerAnswers, 'QAElementID')[QAElementID];
    let employeeAnswerTexts = map(filter(employeeAnswers, ['QAElementID', QAElementID]), e => e.QAAnswerText);
    let managerAnswerTexts = map(filter(managerAnswers, ['QAElementID', QAElementID]), e => e.QAAnswerText);
    if (QAInputAnswerType === 5) {
      employeeAnswerTexts = map(employeeAnswerTexts, convert);
      managerAnswerTexts = map(managerAnswerTexts, convert);
    }

    return (
      <Row style={styles.answers}>
        <Col style={{ padding: 0 }} xs={12} md={6}>
          <Answer
            title={<FormattedMessage id="qaelement.answer.employee" />}
            text={employeeAnswerTexts}
            showComment={AllowComment}
            comment={empAns ? empAns.QAAnswerComment : ''}
          />
        </Col>
        <Col style={{ padding: 0 }} xs={12} md={6}>
          {!showOnlyEmployeeAnswers && <Answer
            title={<FormattedMessage id="qaelement.answer.manager" />}
            text={managerAnswerTexts}
            showComment={AllowComment}
            comment={manAns ? manAns.QAAnswerComment : ''}
          />}
        </Col>
      </Row>
    );
  }

  render() {
    const {
      QAElementType, Label, Description, showAnswers, showOnlyEmployeeAnswers, noInput,
    } = this.props;
    switch (QAElementType) {
      case 1:
        return <div />;
      case 2:
        return (
          <div>
            <Subheader style={styles.subheader}>{Label}</Subheader>
            {Description &&
            <Subheader
              style={{
                ...styles.subheader,
                fontSize: 14,
                lineHeight: '14px',
                marginBottom: 32,
              }}
              dangerouslySetInnerHTML={{ __html: Description }}
            />
            }
          </div>
        );
      case 3:
        return (
          <Paper style={styles.input}>
            <div style={styles.questionRoot}>
              <div style={styles.question}>
                <span>{Label}</span>
                <span style={styles.description} dangerouslySetInnerHTML={{ __html: Description }} />
              </div>
              {(showAnswers || showOnlyEmployeeAnswers) && this.renderAnswers()}
              {noInput && !showOnlyEmployeeAnswers && this.renderFinalAnswer()}
              {!noInput && this.renderInput()}
              {!noInput && this.renderComment()}
            </div>
          </Paper>
        );
      default:
        return <div />;
    }
  }
}

QAElement.defaultProps = {
  AllowComment: false,
  Description: '',
  employeeAnswers: [],
  finalAnswers: [],
  Label: '',
  managerAnswers: [],
  noInput: false,
  showAnswers: false,
  showOnlyEmployeeAnswers: false,
};

QAElement.propTypes = {
  AllowComment: PropTypes.bool,
  Description: PropTypes.string,
  employeeAnswers: PropTypes.array,
  finalAnswers: PropTypes.array,
  Label: PropTypes.string,
  managerAnswers: PropTypes.array,
  noInput: PropTypes.bool,
  QAElementID: PropTypes.number.isRequired,
  QAElementType: PropTypes.number.isRequired,
  QAInput: PropTypes.object,
  showAnswers: PropTypes.bool,
  showOnlyEmployeeAnswers: PropTypes.bool,
  disabled: PropTypes.bool,
};

export default QAElement;



// WEBPACK FOOTER //
// ./src/components/QAElement.js